import UserStorage from './user';

export const userStorage = new UserStorage();
